import {
  REQUEST,
  SUCCESS,
  FAILURE,
  SOCKET,
} from 'flaivy-react/reducers/action-type';
import { ACTION_TYPES } from '../actions/generated/price-list.actions';

const initialState = {
  loading: false,
  entity: {},
  error: {},
  total: 0,
  page: 0,
  hasMore: true,
  query: {},
  search: '',
  sort: 'name',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_PRICE_LIST):
    case REQUEST(ACTION_TYPES.UPSERT_PRICE_LIST): {
      return {
        ...state,
        loading: true,
      };
    }
    case FAILURE(ACTION_TYPES.FETCH_PRICE_LIST):
    case FAILURE(ACTION_TYPES.UPSERT_PRICE_LIST): {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    }

    case 'PRICE_LIST_LOAD_MORE_PRICE_LIST_ENTRIES': {
      const { paylaod } = action;
      const priceListEntries = [
        ...(state.entity.priceListEntries || []),
        ...paylaod.priceListEntries,
      ];
      return {
        ...state,
        entity: {
          ...state.entity,
          priceListEntries,
        },
        total: paylaod.total,
        page: paylaod.page,
        hasMore: priceListEntries.length < paylaod.total,
        query: paylaod.query,
      };
    }
    case SUCCESS(ACTION_TYPES.FETCH_PRICE_LIST): {
      const entity = action.payload;

      return {
        ...state,
        entity,
        loading: false,
      };
    }
    case SOCKET('PRICE_LIST_UPDATED'):
    case SOCKET('PRICE_LIST_CREATED'):
    case SOCKET('PRICE_LIST_ACTIVATED'):
    case SOCKET('PRICE_LIST_DEACTIVATED'):
    case SOCKET('PRICE_LIST_UPDATED'): {
      const { fullEntity } = action.payload;
      if (fullEntity.id === state.entity.id) {
        return {
          ...state,
          entity: fullEntity,
        };
      } else {
        return state;
      }
    }
    default:
      return state;
  }
};

export default reducer;
